import React from "react";
import { AD_STATUS, formatSubmittedAt } from "./adsConstants";
import timelineActiveIcon from "../../assets/images/icons/ads-timeline-active.svg";
import timelinePendingIcon from "../../assets/images/icons/ads-timeline-pending.svg";
import timelineDoneIcon from "../../assets/images/icons/ads-timeline-done.svg";
import timelineInReviewIcon from "../../assets/images/icons/ads-timeline-rejected.svg";
import closeCircleIcon from "../../assets/images/icons/ads-close-circle.svg";

/**
 * Horizontal stepper matching the Figma "View Ad Detail" screen (read-only access, matched
 * from a shared screenshot): Submitted (done) -> In Review (current, red circle) -> Approved
 * (pending, gray ring). No Draft step - the real flow goes straight to Submitted for Review,
 * there's no separate user-visible Draft stage. A Rejected ad still shows Submitted and In
 * Review as done (it genuinely passed through both before being rejected) with "Rejected"
 * replacing "Approved" as the final, danger-colored step.
 */
export default function AdStatusTimeline({ ad }) {
  const isRejected = ad.status === AD_STATUS.REJECTED;
  const reachedSubmitted = ad.status !== AD_STATUS.DRAFT;
  const reachedApproved = [AD_STATUS.APPROVED, AD_STATUS.ACTIVE, AD_STATUS.PAUSED].includes(ad.status);
  const reviewResolved = reachedApproved || isRejected;
  const inReview = reachedSubmitted && !reviewResolved;

  const steps = [
    {
      label: "Submitted",
      icon: reviewResolved ? timelineDoneIcon : timelineActiveIcon,
      textDone: reachedSubmitted,
      at: reachedSubmitted ? ad.updated_at : null,
    },
    {
      label: "In Review",
      icon: reviewResolved ? timelineDoneIcon : timelineInReviewIcon,
      textDone: reviewResolved,
      current: inReview,
      at: reachedSubmitted ? ad.updated_at : null,
    },
    isRejected
      ? { label: "Rejected", icon: closeCircleIcon, danger: true, at: ad.updated_at }
      : {
          label: "Approved",
          icon: reachedApproved ? timelineDoneIcon : timelinePendingIcon,
          textDone: reachedApproved,
          at: reachedApproved ? ad.updated_at : null,
        },
  ];

  return (
    <div className="flex items-start mt-4">
      {steps.map((step, i) => (
        <div key={step.label} className={`flex flex-col items-center ${i < steps.length - 1 ? "flex-1" : ""}`}>
          <div className="flex items-center w-full">
            {i > 0 && (
              <span className={`h-0.5 flex-1 ${steps[i - 1].textDone ? "bg-[#39b54a]" : "bg-[#cccccc]"}`} />
            )}
            <img src={step.icon} alt="" className="w-8 h-8 shrink-0" />
            {i < steps.length - 1 && <span className={`h-0.5 flex-1 ${step.textDone ? "bg-[#39b54a]" : "bg-[#cccccc]"}`} />}
          </div>
          <p
            className={`text-sm font-semibold mt-2 ${
              step.danger ? "text-[#D44A3B]" : step.textDone || step.current ? "text-[#095228]" : "text-[#9a9a9a]"
            }`}
          >
            {step.label}
          </p>
          {step.at && <p className="text-xs text-[#747474]">{formatSubmittedAt(step.at)}</p>}
        </div>
      ))}
    </div>
  );
}
